(function () {
  'use strict';
  var roots = document.querySelectorAll('[data-newsletter-footer]');
  function read(key) {
    try { return JSON.parse(window.localStorage.getItem(key) || '{}') || {}; } catch (_) { return {}; }
  }
  function known() {
    var contact = read('cinta_checkout_contact_v1');
    return (contact.marketing_authorized === true && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email || '')) || read('cinta_newsletter_popup_v1').subscribed === true;
  }
  Array.prototype.forEach.call(roots, function (root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var footer = root.closest('footer');
    var utilities = footer && footer.querySelector('.footer-utilities');
    if (utilities && typeof window.matchMedia === 'function') {
      var home = document.createComment('newsletter-footer-position');
      root.parentNode.insertBefore(home, root);
      var mobile = window.matchMedia('(max-width: 749px)');
      function positionCard() {
        if (mobile.matches) utilities.parentNode.insertBefore(root, utilities);
        else home.parentNode.insertBefore(root, home.nextSibling);
      }
      positionCard();
      if (mobile.addEventListener) mobile.addEventListener('change', positionCard);
      else mobile.addListener(positionCard);
    }
    var form = root.querySelector('form');
    var input = form.elements.email;
    var button = form.querySelector('button');
    var error = root.querySelector('[data-footer-error]');
    var completed = false;
    function update() {
      if (!completed) root.hidden = known();
      var imageBox = root.querySelector('[data-footer-image]');
      if (!root.hidden && imageBox && !imageBox.querySelector('img')) {
        var image = document.createElement('img');
        image.alt = '';
        image.width = 700;
        image.height = 1050;
        image.loading = 'lazy';
        image.decoding = 'async';
        image.src = root.getAttribute('data-image');
        imageBox.appendChild(image);
      }
    }
    update();
    window.addEventListener('storage', update);
    window.addEventListener('cinta:contact-saved', update);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (button.disabled) return;
      input.value = input.value.trim().toLowerCase();
      if (!input.value || !input.checkValidity()) {
        error.textContent = 'Informe um e-mail válido.';
        error.hidden = false;
        input.focus();
        return;
      }
      var email = input.value;
      error.hidden = true;
      button.disabled = true;
      button.textContent = 'Cadastrando…';
      fetch(window.MansaIntimaApiBase + '/api/calcular-frete/newsletter.php', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, consent: true, source: 'footer', website: form.elements.website.value })
      }).then(function (response) {
        return response.json().then(function (data) { if (!response.ok || !data.success) throw new Error(); });
      }).then(function () {
        completed = true;
        try {
          var contact = read('cinta_checkout_contact_v1');
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email || '') || String(contact.email).trim().toLowerCase() === email) {
            window.localStorage.setItem('cinta_checkout_contact_v1', JSON.stringify({ email: email, marketing_authorized: true }));
          }
          window.localStorage.setItem('cinta_newsletter_popup_v1', JSON.stringify({ subscribed: true }));
        } catch (_) {}
        form.hidden = true;
        root.querySelector('[data-footer-success]').hidden = false;
        window.dispatchEvent(new Event('cinta:contact-saved'));
      }).catch(function () {
        error.textContent = 'Não foi possível concluir o cadastro. Tente novamente.';
        error.hidden = false;
      }).finally(function () {
        button.disabled = false;
        button.textContent = 'Quero receber novidades e ofertas';
      });
    });
  });
}());
